import React, {FC} from 'react';
import Button from 'components/Button';
import {HubSpotForm} from 'components/ContentPagesComponents/HubSpotForm';
import {ReviewBar} from 'components/ContentPagesComponents/ReviewBar';
import DynamicAsset from 'components/DynamicAsset';
import {Markdown} from 'components/Markdown';
import OmniButton from 'components/OmniButton';
import {navigate} from 'gatsby';
import {useToggle} from 'hooks/useToggle';

import * as styles from './styles.module.scss';

type CoverShortButtonProps = {
	actionBtnText?: string;
	actionBtnLink?: string;
	actionBtnForm?: string;
}

const CoverShortButton: FC<CoverShortButtonProps> = ({actionBtnText, actionBtnLink, actionBtnForm}) => {
	const {open: show, toggle: toggleForm} = useToggle(false);

	if (actionBtnLink) {
		return (
			<Button variant='light' onClick={() => navigate(actionBtnLink)}>
				{actionBtnText}
			</Button>
		);
	}
	if (actionBtnForm) {
		const Form = HubSpotForm(actionBtnForm);
		return (
			<>
				<Button variant='light' onClick={toggleForm}>
					{actionBtnText}
				</Button>
				{show && (
					<Form show={show} onClose={toggleForm} />
				)}
			</>
		);
	}
	return null;
};

export type CoverShortProps = {
	imageSrc: string;
	mobileSrc?: string;
	title: string;
	subTitle: string;
	score?: number;
	clients?: number;
	actionBtnText?: string;
	actionBtnLink?: string;
	actionBtnForm?: string;
	actionBtnConfig?: string;
}

const defaultClients = 180000;

const CoverShort: FC<CoverShortProps> = ({
	imageSrc,
	mobileSrc,
	title,
	subTitle,
	score,
	clients = defaultClients,
	actionBtnText,
	actionBtnLink,
	actionBtnForm,
	actionBtnConfig,
}) => {
	return (
		<div className={styles.container}>
			<div className={styles.wrapper}>
				<div className={styles.foreground}>
					<div className={styles.text}>
						{score && (
							<ReviewBar
								score={score}
								clients={clients}
							/>
						)}
						<h1>
							<Markdown markdown={title} spanify />
						</h1>
						<h2>
							<Markdown markdown={subTitle} spanify />
						</h2>
						{actionBtnConfig ? (
							<OmniButton
								variant='light'
								className={styles.button}
								actionBtnText={actionBtnText}
								actionBtnConfig={actionBtnConfig}
							/>
						) : (
							actionBtnText && (actionBtnForm || actionBtnLink) && (
								<CoverShortButton
									actionBtnText = {actionBtnText}
									actionBtnLink = {actionBtnLink}
									actionBtnForm = {actionBtnForm}
								/>
							))}
					</div>
				</div>
				<div className={styles.background}>
					<DynamicAsset
						className={styles.imgDesktop}
						imageSrc={imageSrc}
					/>
					<DynamicAsset
						className={styles.imgMobile}
						imageSrc={mobileSrc ?? imageSrc}
					/>
				</div>
			</div>
		</div>
	);
};

export default CoverShort;
